import React from 'react';
import ButtonDesigned from '@UI-Elements/Buttons/ButtonDesigned';
import { useState } from 'react';
import { OptionSelect } from '../../../../../components/UI-Elements/Select/OptionSelect';
import { useRouteById } from '../../../../../hooks/useRouteById';
import { IRouteDetails } from '../../../../../sp-types/routeDetailsType';
import { RouteDetailsComponentMap } from '../../routeDetailsUtils';
import {
  editRouteDetailsHandleAddComponent,
  editRouteDetailsHandleDeleteItem,
  editRouteDetailsHandleIndexChange,
  editRouteDetailsUpdateOffset,
  editRouteDetailsUpdateRouteDetail,
} from './editRouteDetailsUtils';

export const EditRouteDetails: React.FC<IInputProps> = ({ routeDetailsData, setRouteDetails }) => {
  const [selectedOptionToAdd, setSelectedOptionToAdd] = useState('');
  const { data } = useRouteById([routeDetailsData.id]);

  return (
    <div className="flex flex-col gap-3 ">
      {routeDetailsData.routeDetails.map((detail, index) => {
        const Component = RouteDetailsComponentMap[detail.type].inputComponent;
        const props = {
          ...detail.data,
          update: (newData: any) => editRouteDetailsUpdateRouteDetail(index, newData, setRouteDetails),
          route: data?.[0],
          routeId: routeDetailsData.id,
        };
        return (
          <>
            <div key={index} className="flex gap-2">
              <div className="flex gap-2 ">
                <div className="">
                  <p className="text-sm text-gray-450">index </p>
                  <input
                    type="number"
                    className="border rounded-md w-10"
                    value={index}
                    onChange={(e) =>
                      editRouteDetailsHandleIndexChange(
                        index,
                        parseInt(e.target.value),
                        routeDetailsData,
                        setRouteDetails,
                      )
                    }
                    placeholder="index"
                  />
                </div>
                <div className=" ">
                  <p className="text-sm text-gray-450">offset </p>
                  <input
                    type="number"
                    className="border flex rounded-md w-10  "
                    value={detail.offset}
                    onChange={(e) => editRouteDetailsUpdateOffset(index, parseInt(e.target.value), setRouteDetails)}
                    placeholder="offset"
                  />
                </div>
              </div>
              <div className="flex flex-1" style={{ paddingLeft: detail.offset + 'rem' }}>
                <Component {...props} />
              </div>
              <button
                className="text-red-500 text-sm mb-auto border p-1 rounded-md"
                onClick={() => editRouteDetailsHandleDeleteItem(index, setRouteDetails)}
              >
                X
              </button>
            </div>
            <div className="w-full border-b border-gray-150"></div>
          </>
        );
      })}
      <div className="flex flex-row flex-0  mx-auto gap-2 border p-2 rounded-md shrink">
        <OptionSelect
          options={Object.keys(RouteDetailsComponentMap)}
          currentOption={selectedOptionToAdd}
          setCurrentOption={setSelectedOptionToAdd}
        />

        <ButtonDesigned
          style="outline"
          className="py-0"
          onButtonClick={() => {
            editRouteDetailsHandleAddComponent(selectedOptionToAdd, RouteDetailsComponentMap, setRouteDetails);
          }}
        >
          Add New Component
        </ButtonDesigned>
      </div>
    </div>
  );
};

interface IInputProps {
  routeDetailsData: IRouteDetails;
  setRouteDetails: React.Dispatch<React.SetStateAction<IRouteDetails>>;
}
